import { render, staticRenderFns } from "./ConfirmAccountChangeRequest.vue?vue&type=template&id=d1c78714&scoped=true"
import script from "./ConfirmAccountChangeRequest.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountChangeRequest.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAccountChangeRequest.vue?vue&type=style&index=0&id=d1c78714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c78714",
  null
  
)

export default component.exports